<template>
  <logo-layout 
    :title="$t('pages.login.modificar')" 
    :description="$t('pages.login.modificarTexto')" 
  >
    <v-layout justify-center>
      <v-flex xs12 sm8 md6 lg5 xl3>
        <v-card>
          <v-container fluid>
            <CambiarPassword
              @passwordModificada="passwordModificada"
              :conPasswordUsoUnico="true"
            />
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </logo-layout>
</template>

<script>
import CambiarPassword from '@/components/cambiarPassword/CambiarPassword'
export default {
  components: {CambiarPassword},
  methods: {
    passwordModificada () {
      this.$router.push({
        name: 'home'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/login/modificarPassword.vue